<template>
  <section class="section-blog bg-white p-t-80 p-b-100">
    <div class="container">
      <div class="title-section-ourmenu t-center m-b-22">
        <span class="tit2 t-center">EVENT</span>
        <h3 class="tit5 t-center m-t-2">體驗活動</h3>
      </div>
      <div class="row">
        <div
          class="col-md-4 p-t-30"
          v-for=" (vendorActivity,index) in configBlogData"
          v-if="index<=2"
        >
          <div class="wrap-pic-blo1 bo-rad-10 hov-img-zoom pos-relative">
            <router-link :to="vendorActivity.routeName">
              <img
                :src="vendorActivity.activityBlogImages[0]"
                alt="IMG-BLOG"
                width="360px"
                height="214px"
              >
            </router-link>
            <div
              class="time-blog"
            >{{vendorActivity.activityDate.date}} {{vendorActivity.activityDate.month}} {{vendorActivity.activityDate.year}}</div>
          </div>

          <div class="wrap-text-blo1 p-t-35">
            <div>
              <router-link :to="vendorActivity.routeName"  style="text-decoration:none;">
                <h4 class="txt5 color0-hov trans-0-4 m-b-13">{{vendorActivity.activityTitle}}</h4>
              </router-link>
              <p class="m-b-20" v-html="vendorActivity.activityContent[0].substring(0,75)+readMore"></p>
              <router-link :to="vendorActivity.routeName" class="txt4" style="text-decoration:none;">
                我有興趣！
                <i class="fa fa-long-arrow-right m-l-10" aria-hidden="true"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped >
</style>
<script >
export default {
  name: "Blog",
  data() {
    return {
      configBlogData: [],
      readMore:" ....."
    };
  },
  methods: {},
  created() {
    let self = this;
    const p = new Promise((resolve, reject) => {
      let data = [];
      const readVendorInfo = firebaseDB.ref("activities");
      readVendorInfo.orderByChild("vendorName").on("value", function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
          data.push(childSnapshot.val());
        });
        resolve(data);
      });
    }).then(data => {
      self.configBlogData = data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue